import { useSyncExternalStore } from "react";
import { session } from "../api";
import type { StoredAdminSession } from "./session";

/** The stored admin session, updated on sign-in, refresh and sign-out (any tab). */
export function useSession(): StoredAdminSession | null {
  return useSyncExternalStore(session.subscribe, session.current);
}
